module.exports = __webpack_public_path__ + "img/LaCasaDeToño-C.d1a0e2ef.png";